export enum AssessmentAlgorithmResult {
  NO_ALGORITHM_RESULT = 'NO_ALGORITHM_RESULT',
  ALGORITHM_RESULT_NOT_OK = 'ALGORITHM_RESULT_NOT_OK',
  ALGORITHM_RESULT_OK = 'ALGORITHM_RESULT_OK',
  ALGORITHM_RESULT_COMPLETED = 'ALGORITHM_RESULT_COMPLETED',
}
